import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso,Loading} from '@gull'
import axios from 'axios'
import swal from "sweetalert2";
import apiCallCompta_correspondance from './Comp/apiCallCompta_correspondance'
import SubmitAndSelectTypeCorrespondence from './Comp/SubmitAndSelectTypeCorrespondence'

//Pour la configuration des codes commerce/caisse/journal 

const useLoad = (urlData,initData,config) => {
    const t = useTranslate();
    const [listData,setListData] = useState([])
    const [loading,setLoading]=useState(true)

    useEffect(function () {
        (async function() {
            if(urlData){
                console.log('la')
                setLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+urlData
                ).then((response) => {
                    setLoading(false)
                    if(config=='commerce'){
                        setListData(response.data.section)
                    }else if(config=='caisse'){
                        setListData(response.data.datas)
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    if(error.response==undefined){
                        swal.fire(t('unknowError'), "", "error");
                    }
                    else if(error.response.status==403){
                        swal.fire(t('forbiddenGeneral'), "", "error");
                    }
                    else {
                        swal.fire(t('unknowError'), "", "error");
                    }
                    setLoading(false)
                })
            }else{
                setListData(initData)
                setLoading(false)
            }
        })()
    }, [urlData])

    return [loading,listData]
}

const OtherCodeConfiguration = (props) => {
    const t = useTranslate();
    const [loading,listData] = useLoad(props.urlData,props.initData,props.config)
    const [correspondenceValue,setCorrespondenceValue] = useState({})
    const [disabledBtn,setDisabledBtn] = useState(false)
    const [validButton,setValidButton] = useState(false)

    useEffect(function () {
        if(listData.length!=0){
            let obj = {}

            if(props.config!='caisse'){
                listData.map(value=>{
                    obj[value.id]= (props.detailConfig && props.detailConfig[props.config]!=null) ? props.detailConfig[props.config][value.id] : ''
                })
            }else{
                obj['default']= (props.detailConfig && props.detailConfig[props.config]!=null) ? props.detailConfig[props.config].default : ''
                listData.map(value=>{
                    value.caisse_ident.map(caisse => {
                        obj[caisse.code]= (props.detailConfig && props.detailConfig[props.config]!=null) ? props.detailConfig[props.config][caisse.code] : ''
                    })
                })
            }
            
            setCorrespondenceValue(obj)
        }
    }, [props.detailConfig,listData])

    useEffect(function () {
        if(Object.keys(correspondenceValue).length!=0){
            setDisabledBtn(false)

            Object.entries(correspondenceValue).map(([key,value])=>{
                if(value=='') setDisabledBtn(true)
            })
        }
    }, [correspondenceValue])

    const handleChange = (e,name) => {
        setCorrespondenceValue({...correspondenceValue, [name]:e.target.value})
    };

    const handleSubmit = () => {    
        let axiosAction = props.detailConfig ? axios.put : axios.post
        let configId = props.detailConfig ? '/'+props.detailConfig.id : ''
        let obj = {
            [props.config]: correspondenceValue,
            type:props.selectType
        }
        if(props.idCompany!='company') obj["other_company"]=props.idCompany
        
        apiCallCompta_correspondance(setValidButton,axiosAction,obj,t,configId,props.setReload)
    };

    return(<>
        {loading ? 
            <Loading></Loading>
        :
            (listData.length==0 && props.msgErrorData) ?
                <div className='mt-2 text-center fw-bold'>{props.msgErrorData}</div>
            :
            <>
                <SubmitAndSelectTypeCorrespondence
                    disabledBtn={disabledBtn}
                    validButton={validButton}
                    handleSubmit={handleSubmit}
                    selectType={props.selectType}
                    setSelectType={props.setSelectType}
                    config={props.config}
                    setReload={props.setReload}
                    company={props.company}
                />
                {props.config=='caisse' &&
                    <div className='row'>
                        <div className="col-12">
                            <CardPerso header={t('defaultValue')}>
                                <div className="mb-1 row d-flex align-items-center">
                                    <div className="col-6">
                                        <p className='m-0 fw-bold'>{t('defaultValue')}</p>
                                    </div>
                                    <div className='col-6'>
                                        <label className='text-muted'>Code</label>
                                        <input 
                                            disabled={validButton}
                                            value={correspondenceValue?.default || ''} 
                                            type="text" 
                                            className='form-control' 
                                            onChange={(e)=>handleChange(e,'default')} 
                                        />
                                    </div>
                                </div>
                            </CardPerso>
                        </div>
                    </div>
                }
                <div className='row'>
                    {listData.map(value=>{
                        return(
                            <div key={value.id} className={`${listData.length==1 ? "col-12" : listData.length==2 ? "col-6" : "col-4"}`}>
                                <CardPerso header={value.name}>
                                    {props.config!='caisse' ?
                                        <div className="mb-1 row d-flex align-items-center">
                                            <div className="col-6">
                                                <p className='m-0 fw-bold'>{value.name}</p>
                                            </div>
                                            <div className='col-6'>
                                                <label className='text-muted'>Code</label>
                                                <input 
                                                    disabled={validButton}
                                                    value={correspondenceValue?.[value.id] || ''} 
                                                    type="text" 
                                                    className='form-control' 
                                                    onChange={(e)=>handleChange(e,value.id)} 
                                                />
                                            </div>
                                        </div>
                                    :
                                        value.caisse_ident.map(item=>{
                                            return(
                                                <div key={item.code} className="mb-1 row d-flex align-items-center">
                                                    <div className="col-6">
                                                        <p className='m-0 fw-bold'>{item.code}</p>
                                                    </div>
                                                    <div className='col-6'>
                                                        <label className='text-muted'>Code</label>
                                                        <input 
                                                            disabled={validButton}
                                                            value={correspondenceValue?.[item.code] || ''} 
                                                            type="text" 
                                                            className='form-control' 
                                                            onChange={(e)=>handleChange(e,item.code)} 
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </CardPerso>
                            </div>
                        )
                    })}
                </div>
            </>
        }
    </>
    )
}

export default OtherCodeConfiguration;